// src/trialUtils.js
import { runTransaction, serverTimestamp } from 'firebase/firestore';
import { db } from './firebaseConfig';
import { PLAN_CONFIG, QUOTA_CYCLE_DAYS } from './planConfig';
import { getSubscriptionDocRef } from './subscriptionDoc';

const DEMO_DAYS = PLAN_CONFIG.demo.durationDays; // 3
const DEMO_LIMITS = PLAN_CONFIG.demo.limits;

export async function ensureTrialOnFirstLogin(phoneNumber) {
  if (!phoneNumber) return { created: false, reason: 'no-phone' };

  const now = new Date();
  const endDate = new Date(now.getTime() + DEMO_DAYS * 24 * 60 * 60 * 1000);
  const cycleEnd = new Date(now.getTime() + QUOTA_CYCLE_DAYS * 24 * 60 * 60 * 1000);
  const ref = getSubscriptionDocRef(phoneNumber);

  // Transaction ensures we only ever create the demo once
  let created = false;
  await runTransaction(db, async (tx) => {
    const snap = await tx.get(ref);
    if (!snap.exists()) {
      tx.set(
        ref,
        {
          plan: 'demo',
          isTrial: true,
          startDate: now,
          endDate: endDate,
          status: 'Active',
          quota: {
            syncedPlan: 'demo',
            cycleStart: now,
            cycleEnd: cycleEnd,
            searches: { used: 0, bonus: 0, limit: DEMO_LIMITS.searches },
            results: { used: 0, bonus: 0, limit: DEMO_LIMITS.results },
            tmBids: { used: 0, bonus: 0, limit: DEMO_LIMITS.tmBids },
            reportRows: { used: 0, bonus: 0, limit: DEMO_LIMITS.reportRows },
          },
          createdAt: serverTimestamp(),
          updatedAt: serverTimestamp(),
        },
        { merge: false }
      );
      created = true;
    }
  });

  return { created };
}
